import ApiServiceWrapper from './../../api-request.service';

const getCountriesApi = {
  getCountriesFromServer(isWCM:boolean = false) {
    const wcmValue = isWCM ? 'YES' : 'NO';
    const url = `get-country?languageCode=EN&isWCM=${wcmValue}`;
    return ApiServiceWrapper.get(url);
  },
};

export default getCountriesApi;
